import getFormEventData from '../../utils/getFormEventData';
import { eventHasRun } from '../../utils/eventTracker';

export const DDC_FORM_INITIATION = 'ddc.form.initiation';

function initiation(
	{
		DDC: {
			dataLayer = {},
			dataLayer: {
				page: { pageInfo: { pageName } = {} } = {},
				vehicles = []
			} = {}
		}
	},
	{ currentTarget, timeStamp }
) {
	let eventObject;
	const form = currentTarget?.closest('form');

	const formEventId =
		form?.querySelector('input[name="formEventId"]')?.value || '';
	const formEventData = getFormEventData({
		form,
		vehicles,
		dataLayer
	});
	const eventMapId = formEventId || formEventData.trackingId;

	// Currently typedSearch forms are not tracked for initiation.
	if (form?.dataset?.formTrackingType === 'typedSearch') {
		eventHasRun(eventMapId, {
			value: {
				formInitiationTime: new Date().getTime()
			}
		});
	} else if (
		// make sure this form has not initialized yet
		!eventHasRun(DDC_FORM_INITIATION, {
			timeStamp
		}) &&
		// only submit formInitiation once
		!eventHasRun(eventMapId, {
			value: {
				formInitiationTime: new Date().getTime()
			}
		})
	) {
		eventObject = {
			eventType: DDC_FORM_INITIATION,
			eventData: {
				element: form,
				formEventId,
				pageName,
				...formEventData
			}
		};
	}

	return eventObject;
}

export default initiation;
